var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vi-alert',{attrs:{"data-testid":"splittest-index-mgJo9D","closable":false,"title":_vm.$t('module_ad_split_test_edit_in_delivery_info'),"type":"warning","show-icon":"","show-border":""}})}
var staticRenderFns = []

export { render, staticRenderFns }